import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'

import Bio from '../components/Bio'
import { rhythm, scale } from '../utils/typography'

import _1 from "../footnotes.css"

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const { previous, next } = this.props.pathContext

    return (
      <div>
        <Helmet title={`${post.frontmatter.title} | ${siteTitle}`} />
        <h1>{post.frontmatter.title}</h1>
        <p
          style={{
            ...scale(-1 / 5),
            display: 'block',
            marginTop: rhythm(-0.5),
            marginBottom: rhythm(1)
          }}
        >
         {post.frontmatter.date}
        </p>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
        <hr
          style={{
            marginBottom: rhythm(1),
          }}
        />
        <Bio author={post.frontmatter.author} />

        <ul
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            listStyle: 'none',
            padding: 0,
          }}
        >
          {previous && (
            <li>
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            </li>
          )}

          {next && (
            <li>
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            </li>
          )}
        </ul>
        <hr
          style={{
            marginBottom: rhythm(1),
          }}
        />
        <div className="utterances-placeholder"/>
      </div>
    )
  }

  componentDidMount() {
    const utterances = document.createElement('script')
    utterances.setAttribute('src', 'https://utteranc.es/client.js')
    utterances.setAttribute('repo', 'mindlink/mindlink.github.io')
    utterances.setAttribute('branch', 'master')
    utterances.setAttribute('issue-term', this.props.pathContext.slug);
    utterances.setAttribute('async', true)

    const container = document.querySelector('.utterances-placeholder')
    container.appendChild(utterances)
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
      }
      ...BlogPostBio_item
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js